import { render, staticRenderFns } from "./EmailConfig.vue?vue&type=template&id=3ab6b5d2"
import script from "./EmailConfig.vue?vue&type=script&lang=js"
export * from "./EmailConfig.vue?vue&type=script&lang=js"
import style0 from "./EmailConfig.vue?vue&type=style&index=0&id=3ab6b5d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports